const CustomTry = () => {
  return (
    <div className='card '>
      <div className='card-body'></div>
    </div>
  )
}

export {CustomTry}
